import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-black border-t border-zinc-900 text-center" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4" data-id="element-80">
        <p className="text-zinc-500 text-sm mb-4" data-id="element-81">
          © 2025 Huerta Productiva 360°. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-6 text-xs text-zinc-600" data-id="element-82">
          <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-83">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-84">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-85">
            Soporte
          </a>
        </div>
      </div>
    </footer>;
}